export class SideNavigationConstants {
    static readonly DRAWER_CLASS = 'dx-drawer-panel-content';
    static readonly OVERLAY_CLASS = 'dx-overlay-content dx-resizable';
    static readonly DRAWER_OVERLAY_CLASS = 'dx-drawer-panel-content dx-overlay dx-widget dx-visibility-change-handler';
    static readonly SET_TRANSLATE = 'translate(-300px,0px)';
    static readonly RESET_TRANSLATE = 'translate(0px,0px)';
    static readonly EXPANDED_WIDTH = '300px';
    static readonly NO_ACCESS_CONFIG = ['ChecklistConfiguration'];
    static readonly QA_ACTION_ACCESS = [
        'CB_AP_MANAGE_VENDORS',
        'WELCOME_LETTER_QUEUE',
        'WelcomeLetter',
        'MASS_COMM_SYSTEM_TEMPLATE' // Should never be deleted, as it is used to control to show Mass Communication System Templates for QA Users
    ];

    static readonly IT_ACTION_ACCESS = [
        'MASS_COMM_SYS_TEMPLATE_CONFIG',
        'PRINT_STATEMENT',
        'ManagementReport',
        'BudgetRule'
    ];

    static readonly TEMP_ACTION_ACCESS = [
        {
            code: 'CIRAHELP',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Cira Help'
        },
        {
            code: 'MASS_COMM_SYSTEM_TEMPLATE',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Mass Communication System Template'
        },
        {
            code: 'MASS_COMM_SYS_TEMPLATE_CONFIG',
            description: '',
            internalOnly: false,
            specificRoleOnly: false,
            title: 'Mass Communication System Template Configuration'
        }
    ];
}
